import { strategyToOptions } from "@/common/utils/strategyToOptions"

export const companyPriceSurveyMode = {
  disabled: 'Desabilitado',
  informational_only: 'Apenas Informacional',
  used_as_price_limit: 'Usado como Limite de Preço'
}

export const companyPriceSurveyModeOptions = strategyToOptions(companyPriceSurveyMode);
